<template>
  <v-card color="grey lighten-3">
    <v-toolbar dark color="blue darken-4">
      <v-btn icon dark @click="close()">
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title>Settings</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items></v-toolbar-items>
      <v-btn dark flat @click="save()" :disabled="!different">Save</v-btn>
    </v-toolbar>
    <v-container>
      <v-layout row wrap justify-center>
        <v-flex xs12 md8>
          <v-subheader class="pl-0">User Controls</v-subheader>
          <v-card>
            <v-list two-line subheader>
              <!-- <v-subheader>User Controls</v-subheader> -->
              <v-list-tile avatar>
                <v-list-tile-content>
                  <v-list-tile-title>Content filtering</v-list-tile-title>
                  <v-list-tile-sub-title>Set the content filtering level to restrict apps that can be downloaded</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile avatar>
                <v-list-tile-content>
                  <v-list-tile-title>Password</v-list-tile-title>
                  <v-list-tile-sub-title>Require password for purchase or use password to restrict purchase</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
            <v-divider></v-divider>
          </v-card>
          <v-subheader class="pl-0">General</v-subheader>
          <v-card>
            <v-list two-line subheader>
              <!-- <v-subheader>General</v-subheader> -->
              <v-list-tile
                avatar
                v-for="(setting, i) in generalSettings"
                :key="i"
                @click="emptyFunc"
              >
                <v-list-tile-action>
                  <v-checkbox v-model="editedUserSettings[setting.prop]" color="blue darken-1"></v-checkbox>
                </v-list-tile-action>
                <v-list-tile-content
                  @click="editedUserSettings[setting.prop] = !editedUserSettings[setting.prop]"
                >
                  <v-list-tile-title>{{setting.name}}</v-list-tile-title>
                  <v-list-tile-sub-title>{{setting.description}}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import UserSettingsService from "@/services/requests/userSettings";
export default {
  data() {
    return {
      editedUserSettings: {},
      generalSettings: [
        {
          name: "Notifications",
          description:
            "Notify me of updates to data changes I am subscribed to",
          value: false,
          prop: "notificationsOn"
        },
        {
          name: "Live updates",
          description: "Subscribe to live updates",
          value: true,
          prop: "liveUpdatesOn"
        }
      ]
    };
  },
  methods: {
    emptyFunc() {},
    close() {
      this.$emit("close");
    },
    toggleSetting() {},
    save() {
      //console.log('save');
      UserSettingsService.updateUserSettings(this.editedUserSettings)
        .then(result => {
          //console.log(result);
          this.snack({ text: result.data.message, color: "green" });
          //TODO SET NEW SETTINGS ON CLIENT
        })
        .catch(err => {
          this.snack({ text: err.response.data.message, color: "red" });
        });
    }
  },
  computed: {
    userSettings() {
      return this.$store.state.user.userSettings;
    },
    different() {
      if (!this._.isEqual(this.userSettings, this.editedUserSettings)) {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted() {
    this.editedUserSettings = Object.assign({}, this.userSettings);
  }
};
</script>

<style>
</style>
